import { render, staticRenderFns } from "./ReplaceRename.vue?vue&type=template&id=08dad33a"
import script from "./ReplaceRename.vue?vue&type=script&lang=js"
export * from "./ReplaceRename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports